import React from "react";
import "./GridCars.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";

const gridCars = props => (
  <Grid container spacing={3} style={{ textAlign: "center", marginTop: "5px" }}>
    <Grid item xs={12}>
      <div className="Title">Autos en Stock</div>
      <div className="Title-middle">
        Estos autos estan en stock fisico <b>LISTOS PARA SER PATENTADOS</b>
      </div>
    </Grid>
    <Grid item xs={12}>
      <CarModel name="COROLLA" />
      <CarModel name="ETIOS" />
    </Grid>
  </Grid>
);

export default gridCars;
